import { Box, Button, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { useNavigate } from "react-router-dom";
import { setNestedObjectValues } from "formik";

function CourseOfferingCalendar() {
  const api = useAxiosPrivate();

  let [regstartdate, setregstartdate] = useState(moment().format("YYYY-MM-DD"));
  let [regenddate, setregenddate] = useState(moment().format("YYYY-MM-DD"));
  let [extstartdate, setextstartdate] = useState(moment().format("YYYY-MM-DD"));
  let [extenddate, setextenddate] = useState(moment().format("YYYY-MM-DD"));
  let [offbatchstartdate, setoffbatchstartdate] = useState(
    moment().format("YYYY-MM-DD")
  );
  let [offbatchenddate, setoffbatchenddate] = useState(
    moment().format("YYYY-MM-DD")
  );
  let [isMounted, setIsMounted] = useState(true);

  let [changed, setchanged] = useState({
    reg: [false, false],
    ext: [false, false],
    out: [false, false],
  });

  let { setError, setVal } = useContext(CourseAssignmentContext);
  let [assigned, setassigned] = useState([false, false, false]);

  let navigate = useNavigate();

  async function getCalendar(signal) {
    try {
      let respdata = await api.get(`courseallocation/getofferingtimetable`, {
        signal,
      });

      isMounted && alignCalendar(respdata.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  }

  function alignCalendar(data) {
    data.forEach((time) => {
      if (time.type.toLowerCase().trim() == "Regular".toLowerCase().trim()) {
        let prev = assigned;
        prev[0] = true;
        setassigned(prev);
        setregstartdate(moment(time.start_date).format("YYYY-MM-DD"));
        setregenddate(moment(time.end_date).format("YYYY-MM-DD"));
      } else if (
        time.type.toLowerCase().trim() == "Extension".toLowerCase().trim()
      ) {
        let prev = assigned;
        prev[1] = true;
        setassigned(prev);
        setextstartdate(moment(time.start_date).format("YYYY-MM-DD"));
        setextenddate(moment(time.end_date).format("YYYY-MM-DD"));
      } else if (
        time.type.toLowerCase().trim() == "OffBatch".toLowerCase().trim()
      ) {
        let prev = assigned;
        prev[2] = true;
        setassigned(prev);
        setoffbatchstartdate(moment(time.start_date).format("YYYY-MM-DD"));
        setoffbatchenddate(moment(time.end_date).format("YYYY-MM-DD"));
      }
    });
  }

  async function handlesave() {
    let output = {
      regular: {},
      extension: {},
      offbatch: {},
    };

    if (changed.reg[0] == true) {
      output.regular.start_date = regstartdate;
    }
    if (changed.reg[1] == true) {
      output.regular.end_date = regenddate;
    }
    if (changed.ext[0] == true) {
      output.extension.start_date = extstartdate;
    }
    if (changed.ext[1] == true) {
      output.extension.end_date = extenddate;
    }
    if (changed.out[0] == true) {
      output.offbatch.start_date = offbatchstartdate;
    }
    if (changed.out[1] == true) {
      output.offbatch.end_date = offbatchenddate;
    }

    let resp = await api.post("courseallocation/settimeline", output);
    if (resp.data.msg == true) {
      let respdata = await api.get(`courseallocation/getofferingtimetable`);

      alignCalendar(respdata.data);
    } else {
      setError("Invalid Date");
    }
  }

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getCalendar(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);
  useEffect(() => {
    console.log(changed);
  }, [changed]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          width: "90%",
          border: "2px solid lightgray",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          style={{
            width: "90%",
            borderBottom: "1px solid gray",
            marginBottom: "10px",
            paddingBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              marginBottom: "15px",
            }}
          >
            <h1 className="Offering-header">Regular Program</h1>
            {regenddate >= moment().format("YYYY-MM-DD") &&
              assigned[0] == true && (
                <span
                  style={{
                    width: "30px",
                    height: "20px",
                    padding: "2px 2px",
                    fontSize: "14px",
                    marginTop: "15px",
                    color: "green",
                    fontWeight: "bold",
                  }}
                >
                  Active
                </span>
              )}
            {regenddate < moment().format("YYYY-MM-DD") && assigned[0] == true && (
              <span
                style={{
                  width: "30px",
                  height: "20px",
                  padding: "2px 2px",
                  fontSize: "14px",
                  marginTop: "15px",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Expired
              </span>
            )}
          </div>

          <TextField
            id="date"
            label="Start Date"
            type="date"
            defaultValue="2017-05-24"
            sx={{ width: 220, margin: "0px 30px" }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: moment().format("YYYY-MM-DD"),
            }}
            value={regstartdate}
            onChange={(e) => {
              setregstartdate(e.target.value);
              let prev = changed;
              console.log(prev);
              prev.reg[0] = true;
              setchanged(prev);
            }}
          />

          <TextField
            id="date"
            label="End Date"
            type="date"
            defaultValue="2017-05-24"
            sx={{ width: 220, margin: "0px 30px" }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: regstartdate,
            }}
            value={regenddate}
            onChange={(e) => {
              setregenddate(e.target.value);
              let prev = changed;
              console.log(prev);
              prev.reg[1] = true;
              setchanged(prev);
            }}
          />
        </Box>

        <Box
          style={{
            width: "90%",
            borderBottom: "1px solid gray",
            marginBottom: "10px",
            paddingBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              marginBottom: "15px",
            }}
          >
            <h1 className="Offering-header">Extension Program</h1>
            {extenddate >= moment().format("YYYY-MM-DD") &&
              assigned[1] == true && (
                <span
                  style={{
                    width: "30px",
                    height: "20px",
                    padding: "2px 2px",
                    fontSize: "14px",
                    marginTop: "15px",
                    color: "green",
                    fontWeight: "bold",
                  }}
                >
                  Active
                </span>
              )}
            {extenddate < moment().format("YYYY-MM-DD") && assigned[1] == true && (
              <span
                style={{
                  width: "30px",
                  height: "20px",
                  padding: "2px 2px",
                  fontSize: "14px",
                  marginTop: "15px",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Expired
              </span>
            )}
          </div>

          <TextField
            id="date"
            label="Start Date"
            type="date"
            defaultValue="2017-05-24"
            sx={{ width: 220, margin: "0px 30px" }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: moment().format("YYYY-MM-DD"),
            }}
            value={extstartdate}
            onChange={(e) => {
              setextstartdate(e.target.value);
              let prev = changed;
              console.log(prev);
              prev.ext[0] = true;
              setchanged(prev);
            }}
          />

          <TextField
            id="date"
            label="End Date"
            type="date"
            defaultValue="2017-05-24"
            sx={{ width: 220, margin: "0px 30px" }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: extstartdate,
            }}
            value={extenddate}
            onChange={(e) => {
              setextenddate(e.target.value);
              let prev = changed;
              console.log(prev);
              prev.ext[1] = true;
              setchanged(prev);
            }}
          />
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignITems: "center",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{ margin: "25px 25px" }}
            onClick={() => {
              setVal("ca");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ margin: "25px 25px" }}
            onClick={handlesave}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CourseOfferingCalendar;

// <Box style={{
//   width:"90%",
//   borderBottom:"1px solid gray",
//   marginBottom:"10px",
//   paddingBottom:"20px",
// }}>

// <div style={{
//   display:"flex",
//   alignItems:"center",
//   justifyContent:"flex-start",
//   marginBottom:"15px"
// }}>
// <h1 className="Offering-header">Off Batch Program</h1>
// {(offbatchenddate>=moment().format('YYYY-MM-DD')&& assigned[2]==true) &&(<span style={{
//   width:"30px",
//   height:"20px",
//   padding:"2px 2px",
//   fontSize:"14px",
//   marginTop:"15px",
//   color:"green",
//   fontWeight:"bold"
// }}>Active</span>)}{offbatchenddate<moment().format('YYYY-MM-DD')&& assigned[2]==true &&(
//   <span style={{
//       width:"30px",
//       height:"20px",
//       padding:"2px 2px",
//       fontSize:"14px",
//       marginTop:"15px",
//       color:"red",
//       fontWeight:"bold"
//   }}>Expired</span>
// )}
// </div>

//   <TextField
//   id="date"
//   label="Start Date"
//   type="date"
//   defaultValue="2017-05-24"
//   sx={{ width: 220,margin:"0px 30px" }}
//   InputLabelProps={{
//     shrink: true,
//   }}
//   inputProps={{
//       min: moment().format('YYYY-MM-DD'),
//     }}
//   value={offbatchstartdate}
//   onChange={(e)=>{setoffbatchstartdate(e.target.value)
//       let prev=changed
//       console.log(prev)
//       prev.out[0]=true
//       setchanged(prev)
//       }}
// />

// <TextField
//   id="date"
//   label="End Date"
//   type="date"
//   defaultValue="2017-05-24"
//   sx={{ width: 220,margin:"0px 30px" }}
//   InputLabelProps={{
//     shrink: true,
//   }}
//   inputProps={{
//       min: offbatchstartdate,
//     }}
//   value={offbatchenddate}
//   onChange={(e)=>{setoffbatchenddate(e.target.value)
//       let prev=changed
//       console.log(prev)
//       prev.out[1]=true
//       setchanged(prev)}}
// />

// </Box>
